import { defineComponent as _defineComponent } from 'vue'
import { getHostname } from '@@/bits/url'
import type { AudioSearchResult, VideoSearchResult } from '@@/bits/web_search'
import { SearchFilters } from '@@/bits/web_search'
import FallbackAudio from '@@/images/fallback_audio.png'
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import { nextTick, onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPickerSearchResultsAv',
  props: {
    results: null,
    filter: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'select', url: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  results: (AudioSearchResult | VideoSearchResult)[]
  filter: SearchFilters
};





const LOADING_IMAGES_BG_COLOR = ['red', 'blue', 'green', 'yellow', 'purple', 'pink', 'cyan', 'orange']
const CROP_ASPECT_RATIO = 1.8 /* 16.2:9 to remove borders nicely since 16/9=1.(7) is non-terminating */
const DEFAULT_THUMBNAIL_HEIGHT = 768
const DEFAULT_THUMBNAIL_WIDTH = DEFAULT_THUMBNAIL_HEIGHT * CROP_ASPECT_RATIO

const container = ref<HTMLUListElement>()
const imageWrappers = ref<HTMLLIElement[]>()

const imageWidth = ref(0)

const handleResultsUpdate = async (): Promise<void> => {
  await nextTick()
  imageWidth.value = imageWrappers.value && imageWrappers.value[0] ? imageWrappers.value[0].clientWidth : 0
}

const select = (url: string): void => {
  emit('select', url)
}

const audioDescription = (result: AudioSearchResult): string => {
  if (result.release_date) {
    // podcast episode
    const showName = result.show_name
    if (showName) {
      return showName + ' · ' + new Date(result.release_date).toLocaleDateString()
    }
    let shortenedDescription = result.description.split(' ').slice(0, 15).join(' ')
    if (shortenedDescription.length < result.description.length) {
      shortenedDescription = shortenedDescription + '...'
    }
    return new Date(result.release_date).toLocaleDateString() + ' · ' + shortenedDescription
  }
  return result.description
}

const providerName = (result: VideoSearchResult): string => {
  if (result.provider_name) return result.provider_name
  return getHostname(result.url)
}

const isUsingFallbackThumbnail = (result: AudioSearchResult): boolean => {
  return !result.thumbnail_url || result.thumbnail_url === ''
}

watch(() => props.results, handleResultsUpdate)

onMounted((): void => {
  imageWidth.value = (container.value?.clientWidth ?? 0) / 3 - 12
  // After the components are auto-layouted, we assigned the fixed imageWidth so that
  // Beethoven-Vivaldi can load the most size-optimal image
  handleResultsUpdate()
})

return { __sfc: true,props, emit, LOADING_IMAGES_BG_COLOR, CROP_ASPECT_RATIO, DEFAULT_THUMBNAIL_HEIGHT, DEFAULT_THUMBNAIL_WIDTH, container, imageWrappers, imageWidth, handleResultsUpdate, select, audioDescription, providerName, isUsingFallbackThumbnail, SearchFilters, FallbackAudio, ImageThumbnail }
}

})